import classNames from 'classnames';
import { useCallback, useContext } from 'react';
import T from '../../../../../../common/components/T';
import UserContext from '../../../../../../common/utils/getContext';
import uikit from '../../../../../../project/uikit/styles';
import FormButtons from '../../../../../../widgets/form/form-control-buttons/FormButtons/FormButtons';
import Form from '../../../../../external_form/ExternalForm';
import { changeEmailFunc } from '../helpers';
import css from './ChangeEmail.module.scss';

const ChangeEmail = ({ setStepData, data }) => {
    const { lang, setAlertData } = useContext(UserContext);
    const sender = useCallback(
        (dataToSend, setAllowedSend, setFieldsErr) => {
            changeEmailFunc(data, setStepData, lang, setAlertData, dataToSend, setAllowedSend, setFieldsErr);
        },
        [data, lang, setAlertData, setStepData]
    );
    return (
        <>
            <p className={classNames(css.authHeadingTitle, css.authHeadingTitleChange)}>
                <T page='/authentication' textName='confirm-auth-ChangeEmail-title' defaultStr='Укажите корректный e-mail' />
            </p>
            <Form
                formStyles={{ email: { wrapper: uikit.mb4 } }}
                data={{
                    data: [
                        {
                            placeholder: 'johndoe@gmail.com',
                            attribute: 'email',
                            title: {
                                body: (
                                    <T
                                        page='/authentication'
                                        textName='confirm-auth-ChangeEmail-form-title'
                                        defaultStr='Введите e-mail'
                                    />
                                )
                            },
                            type: 'input',
                            value: null
                        }
                    ]
                }}
                sendData={{ sender }}
                buttonText={
                    <T
                        page='/authentication'
                        textName='confirm-auth-ChangeEmail-form-button'
                        defaultStr='Отправить письмо на новый e-mail'
                    />
                }
                hoverColor={{
                    hover: 'var(--blueColor)',
                    blur: 'var(--greyDarkColor)'
                }}
                message={{ error: false }}
            />
            <div className={css.wrapButtons}>
                <FormButtons
                    buttons={[
                        {
                            buttonText: <T page='all' textName='back' defaultStr='Назад' />,
                            clickFunc: () => {
                                setStepData((pre) => pre.back);
                            },
                            type: 'cancel'
                        }
                    ]}
                    customFormButton={{ isFullWidth: true }}
                />
            </div>
        </>
    );
};
export default ChangeEmail;
